import React, { useState, useEffect } from 'react';

const News = ({ Icons, apiBase }) => {
    const [newsData, setNewsData] = useState([]);
    const [selectedNote, setSelectedNote] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (apiBase) fetchNews();
    }, [apiBase]);

    const fetchNews = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${apiBase}/news.php`);
            const data = await response.json();
            
            if (Array.isArray(data)) {
                setNewsData(data);
            }
        } catch (error) {
            console.error("خطا در دریافت اخبار:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // تابع کمکی برای ساخت خلاصه متن
    const getSummary = (text, summary) => {
        if (summary) return summary;
        if (!text) return '';
        return text.substring(0, 120) + '...';
    };

    return (
        <div className="container mx-auto px-4 py-12 animate-fadeIn">
            <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-slate-800 mb-4">یادداشت‌ها و اخبار</h1>
                <p className="text-slate-600 max-w-2xl mx-auto">دلنوشته‌ها، اخبار علمی و اطلاع‌رسانی‌های دکتر حر خسروی</p>
            </div>

            {isLoading ? (
                <div className="flex justify-center py-20">
                    <div className="text-slate-500 animate-pulse">در حال دریافت اطلاعات...</div>
                </div>
            ) : newsData.length === 0 ? (
                <div className="text-center py-12 bg-[#e6d8d8] rounded-[30px] shadow-neu-inset">
                    <p className="text-slate-500">هنوز یادداشتی منتشر نشده است.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {newsData.map(note => (
                        <div key={note.id} className="glass-card rounded-[53px] overflow-hidden flex flex-col h-full relative group transition-all duration-300 hover:-translate-y-1">
                            <div className="p-6 flex flex-col h-full">
                                <div className="flex items-center justify-between mb-4">
                                    <span className="text-xs font-bold text-blue-600 bg-[#f0f0f3] shadow-neu-inset px-3 py-1 rounded-full">
                                        {new Date(note.created_at).toLocaleDateString('fa-IR')}
                                    </span>
                                    <div className="h-8 w-8 rounded-full bg-[#f0f0f3] shadow-neu flex items-center justify-center text-slate-400">
                                         <Icons.Calendar size={16} />
                                    </div>
                                </div>
                                <h3 className="text-xl font-bold text-slate-800 mb-3">{note.title}</h3>
                                <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow line-clamp-3">
                                    {getSummary(note.text, note.summary)}
                                </p>
                                <button onClick={() => setSelectedNote(note)} className="text-blue-600 font-bold hover:text-blue-800 flex items-center gap-1 text-sm mt-auto self-end group transition-colors">
                                    ادامه مطلب
                                    <Icons.ChevronLeft size={16} className="transition-transform group-hover:-translate-x-1" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Note Modal */}
            {selectedNote && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black/40 backdrop-blur-md" onClick={() => setSelectedNote(null)}></div>
                    <div className="glass-card bg-[#f0f0f3] w-full max-w-2xl rounded-[53px] shadow-2xl overflow-hidden animate-fadeInScale flex flex-col max-h-[90vh] relative z-10">
                        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-transparent">
                            <h3 className="text-xl font-bold text-slate-800">{selectedNote.title}</h3>
                            <button onClick={() => setSelectedNote(null)} className="text-slate-400 hover:text-red-500 transition-colors p-2">
                                <Icons.X />
                            </button>
                        </div>
                        <div className="p-8 overflow-y-auto custom-scrollbar prose-custom leading-8 text-justify whitespace-pre-wrap">
                            {selectedNote.text}
                        </div>
                        <div className="p-4 border-t border-slate-100 bg-transparent text-left">
                            <span className="text-sm text-slate-500">
                                تاریخ انتشار: {new Date(selectedNote.created_at).toLocaleDateString('fa-IR')}
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default News;